import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const PAY = {
  Cash: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  UPI: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800",
  Card: "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/40 dark:text-indigo-300 dark:border-indigo-800",
  Cheque: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
};

const DELIVERY = {
  Assigned: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  Out_for_Delivery: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800",
  Incomplete: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/40 dark:text-orange-300 dark:border-orange-800",
  Delivered: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  Cancelled: "bg-slate-100 text-slate-600 border-slate-300 line-through dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700",
};

const PAYSTATUS = {
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  Partial: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  Pending: "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  Credit: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
};

export function PaymentBadge({ mode }) {
  return <Badge variant="outline" className={cn("font-mono text-xs", PAY[mode] || PAYSTATUS.Pending)}>{mode}</Badge>;
}

export function DeliveryStatusBadge({ status }) {
  const pulse = status === "Out_for_Delivery";
  return (
    <Badge variant="outline" className={cn("font-mono text-xs", DELIVERY[status] || PAYSTATUS.Pending)}>
      {pulse && <span className="mr-1 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current" />}
      {(status || "").replace(/_/g, " ")}
    </Badge>
  );
}

export function PayStatusBadge({ status }) {
  return <Badge variant="outline" className={cn("font-mono text-xs", PAYSTATUS[status] || PAYSTATUS.Pending)}>{status}</Badge>;
}

export function SpotPayBadge() {
  return (
    <Badge variant="outline" className="border-teal-300 bg-teal-50 font-mono text-[10px] font-bold tracking-wide text-teal-700 dark:border-teal-700 dark:bg-teal-950/40 dark:text-teal-300">
      SPOT PAY
    </Badge>
  );
}
